import { Api } from '@estee/elc-service';
import { FORM_DATA_FIELD, GOOGLE_FORMS_URL } from '~constants/VtoSurvey';

export interface ISurveyData {
    np: string;
    comment: string;
    userIdentifier: string;
    page: string;
    vtoType: string;
}

export class SurveyApiSdk extends Api {
    public saveSurveyData = async (surveyData: ISurveyData): Promise<void> => {
        const url = GOOGLE_FORMS_URL;

        await this.post({
            url,
            headers: {
                'Content-Type': 'application/json'
            },
            options: {
                mode: 'no-cors'
            },
            body: this.getSurveyData(surveyData)
        });
    };

    private getSurveyData = (surveyData: ISurveyData) => {
        const dataToPost = new FormData();

        dataToPost.append(FORM_DATA_FIELD.USER_IDENTIFIER_FIELD, surveyData.userIdentifier);
        dataToPost.append(FORM_DATA_FIELD.PAGE_FIELD, surveyData.page);
        dataToPost.append(FORM_DATA_FIELD.VTO_TYPE_FIELD, surveyData.vtoType);
        dataToPost.append(FORM_DATA_FIELD.NP_FIELD, surveyData.np);
        dataToPost.append(FORM_DATA_FIELD.COMMENT_FIELD, surveyData.comment);

        return dataToPost;
    };
}
